import React from 'react'
import PropTypes from 'prop-types';

import {extractIndividualErrors} from 'validation'
import {getMessage as msg} from 'MessageBundle'
import BaseComponent from 'common/BaseComponent'
import Input from 'common/Input'
import ErrorTooltip from 'common/ErrorTooltip'
import deleteImg from 'common/recycle.jpg';
import complaintStyle from 'dialogs/Complaint.scss'

export default class ImeiList extends BaseComponent {

    render() {
        const errorMessages = extractIndividualErrors(this.props.errorMessages, "imei");
        return (
            <div>
                <div className={complaintStyle.row + " " + complaintStyle.rowImei}>
                    <Input id="newImei" value={this.props.newImei} name="newImei" errorMessages={this.props.errorMessages}
                        onChange={this.props.onChange("newImei")} required tooltip={msg('newComplaint.information.imeiTooltip')}
                        label={msg('newComplaint.information.types.imei') + ":"}/>
                    <button id="addImei-btn" onClick={this.props.onImeiAddition} disabled={this.props.value.length >= this.props.max}>{msg('newComplaint.addImeiBtn')}</button>
                </div>
                <div className={errorMessages.length > 0 ? complaintStyle.filesGroup + " " + complaintStyle.filesGroupError : complaintStyle.filesGroup}>
                    {msg('newComplaint.information.imeiCount') + " (" + this.props.value.length + ")"}
                    <div>
                        <ul>
                            {this.props.value.map((item, idx) => (
                                <li key={idx}>
                                    <span id={this.props.id + '-item-' + idx}>{item}</span>
                                    <button id={this.props.id + '-delete-btn-' + idx} className={complaintStyle.btnDelete} onClick={this.props.onImeiRemoval(idx)}>
                                        <img src={deleteImg} role="presentation"/>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {errorMessages.length > 0 ? <ErrorTooltip for={this.props.id} value={errorMessages}/> : ""}
            </div>
        )
    }
}

ImeiList.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    buttonMessage: PropTypes.string.isRequired,
    inputMin: PropTypes.number,
    inputMax: PropTypes.number,
    max: PropTypes.number,
    formatMessage: PropTypes.string,
    required: PropTypes.bool,
    requiredMessage: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/dialogs/NewComplaint/Form/ImeiList/index.js